'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0.999995H-2.02656e-05V21H28V0.999995Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.9998 14.3333H-0.000183105L-2.02656e-05 21H28L27.9998 14.3333Z",
          fill: "url(#paint0_linear_304_2257)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-2.02656e-05 21H28V0.999995L9.33342 0.999975L-2.02656e-05 0.999995V21Z",
          fill: "#26A7DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33342 0.999975L-2.02656e-05 0.999995L4.83654e-05 7.66664H9.33338L9.33342 0.999975Z",
          fill: "#F03633"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66681 3.3905L2.24955 0.982353L0.381884 0.994553L3.724 4.33331L0.406356 7.67178H2.17637L4.66681 5.27612L7.1202 7.68399H9.0245L5.60962 4.33331L9.01223 1.00676L7.07132 0.99456L4.66681 3.3905Z",
          fill: "#2AA854"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33322 3.66664V0.982353H3.99989V3.66664H-0.000114474V4.99997H3.99989V7.67178H5.33322V4.99997H9.33322V3.66664H5.33322Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.1006 9.57154C24.4705 9.23498 25.3332 9.14561 25.3332 10.3333C25.3332 12.5424 22.3485 14.3333 18.6666 14.3333C14.9847 14.3333 11.9999 12.5424 11.9999 10.3333C11.9999 9.14561 12.8626 9.23498 14.2325 9.57154C14.1456 9.33484 14.0729 9.08398 14.0172 8.82196C13.6345 7.02124 14.2 5.3753 15.2805 5.14564C16.3609 4.91599 17.5471 6.18959 17.9298 7.99031C18.1102 8.83915 18.0799 9.6536 17.8843 10.3015C18.1409 10.3219 18.4019 10.3333 18.6666 10.3333C18.9312 10.3333 19.1922 10.3219 19.4488 10.3015C19.2532 9.6536 19.2229 8.83915 19.4033 7.99031C19.7861 6.18959 20.9722 4.91599 22.0526 5.14564C23.1331 5.3753 23.6986 7.02124 23.3159 8.82196C23.2602 9.08398 23.1875 9.33484 23.1006 9.57154Z",
          fill: "#FBCD3F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.0352 18.2629C21.2229 18.3568 21.4438 18.3568 21.6315 18.2629L24.2982 16.9296C24.6275 16.7649 24.761 16.3645 24.5963 16.0352C24.4317 15.7058 24.0312 15.5724 23.7019 15.737L21.3334 16.9213L18.9648 15.737C18.7772 15.6432 18.5562 15.6432 18.3686 15.737L16 16.9213L13.6315 15.737C13.3022 15.5724 12.9017 15.7058 12.7371 16.0352C12.5724 16.3645 12.7059 16.7649 13.0352 16.9296L15.7019 18.2629C15.8896 18.3568 16.1105 18.3568 16.2982 18.2629L18.6667 17.0787L21.0352 18.2629Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33338 7.66664H4.83654e-05L-0.000183105 14.3333L9.33322 14.3333L9.33338 7.66664Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.99985 10.3333C1.63166 10.3333 1.33319 10.0348 1.33319 9.66665C1.33319 9.29846 1.63166 8.99999 1.99985 8.99999C2.36804 8.99999 2.66652 9.29846 2.66652 9.66665C2.66652 10.0348 2.36804 10.3333 1.99985 10.3333ZM4.66652 10.3333C4.29833 10.3333 3.99985 10.0348 3.99985 9.66665C3.99985 9.29846 4.29833 8.99999 4.66652 8.99999C5.03471 8.99999 5.33319 9.29846 5.33319 9.66665C5.33319 10.0348 5.03471 10.3333 4.66652 10.3333ZM7.33319 10.3333C6.965 10.3333 6.66652 10.0348 6.66652 9.66665C6.66652 9.29846 6.965 8.99999 7.33319 8.99999C7.70138 8.99999 7.99985 9.29846 7.99985 9.66665C7.99985 10.0348 7.70138 10.3333 7.33319 10.3333ZM5.99985 13C5.63166 13 5.33319 12.7015 5.33319 12.3333C5.33319 11.9651 5.63166 11.6667 5.99985 11.6667C6.36804 11.6667 6.66652 11.9651 6.66652 12.3333C6.66652 12.7015 6.36804 13 5.99985 13ZM3.33319 13C2.965 13 2.66652 12.7015 2.66652 12.3333C2.66652 11.9651 2.965 11.6667 3.33319 11.6667C3.70138 11.6667 3.99985 11.9651 3.99985 12.3333C3.99985 12.7015 3.70138 13 3.33319 13Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33322 14.3333L-0.000183105 14.3333L-2.02656e-05 21L9.33319 21L9.33322 14.3333Z",
          fill: "#D7181D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66652 17C2.82557 17 1.33319 16.7015 1.33319 16.3333C1.33319 15.9651 2.82557 15.6667 4.66652 15.6667C6.50747 15.6667 7.99985 15.9651 7.99985 16.3333C7.99985 16.7015 6.50747 17 4.66652 17ZM4.66652 19.6667C2.82557 19.6667 1.33319 19.3682 1.33319 19C1.33319 18.6318 2.82557 18.3333 4.66652 18.3333C6.50747 18.3333 7.99985 18.6318 7.99985 19C7.99985 19.3682 6.50747 19.6667 4.66652 19.6667Z",
          fill: "#FBCD3F"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_304_2257",
          x1: 13.9999,
          y1: 0.982353,
          x2: 13.9999,
          y2: 21,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#138E16" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#0F7F12" })
          ]
        }
      ) })
    ]
  }
);
const VpFlagPmAsset = forwardRef(FlagPmAsset);

export { VpFlagPmAsset as default };
